import axios from "axios";

const postAppointmentHistory = async (baseUrl, token, doctorId, appointmentId, history) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let putResponse = null

    var bodyFormData = new FormData();
    bodyFormData.append('history', history);

    await axios.post(baseUrl + "/doctor/" + doctorId + "/appointment/" + appointmentId + "/history", bodyFormData, config)
        .then((res) => {
            putResponse = {
                status: res.data.status,
                data: res.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                putResponse = {
                    status: error.response.status,
                    data: error.response.status
                }
            }
        });
    return putResponse
}

export default postAppointmentHistory;